import React from "react";
import styles from "./UserPanelLink.module.scss";
import QrCodeIcon from "../../assets/icons/QrCodeIcon";
import DocumentIcon from "../../assets/icons/DocumentIcon";
import ShareIcon from "../../assets/icons/ShareIcon";
import { useNotification } from "../../contexts/NotificationToast";

const UserPanelLink = ({ userData }) => {
  const { showNotification } = useNotification();

  const links = [
    { title: "Реферальный токен", text: userData?.referral_token },
    {
      title: "Реферальная ссылка",
      link: `https://clever-botics.com/auth/register/${userData?.referral_token}`,
    },
  ];

  const handleCopy = async (item) => {
    const textToCopy = item.link || item.text || "";
    if (!textToCopy) {
      showNotification("Нету некста для копирования", 400);
      return;
    }

    try {
      await navigator.clipboard.writeText(textToCopy);
      showNotification(`Скопировано: "${textToCopy}"`, 200);
    } catch (err) {
      showNotification("Ошибка при копировании", 400);
    }
  };

  return (
    <div className={styles.userPanelLinks}>
      {links.map((item, idx) => (
        <div className={styles.userPanelLink} key={idx}>
          <div className={styles.userPanelLinkContent}>
            <h4 className={styles.linkTitle}>{item.title}</h4>
            <span className={styles.link} onClick={() => handleCopy(item)}>
              {item.link || item.text}
            </span>
          </div>
          <div className={styles.actionIcons}>
            <QrCodeIcon />
            <DocumentIcon />
            <ShareIcon />
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserPanelLink;
